import script from "./EmailVerification.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailVerification.vue?vue&type=script&setup=true&lang=js"

import "./EmailVerification.vue?vue&type=style&index=0&id=29ee6740&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29ee6740"]])

export default __exports__